<template>
  <div class="dialog-wrap">
    <el-dialog title="选择题目"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               width="1000px">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="题目"
                      prop="name">
          <el-input v-model="query.keywords"
                    placeholder="请输入"
                    style="width:300px;"
                    @input="fetchExamList(true)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="题型"
                      prop="category_id">
          <el-select v-model="query.answer_type"
                     placeholder="请选择"
                     style="width:150px"
                     @change="fetchExamList(true)"
                     clearable>
            <el-option v-for="(item,index) in answer_type"
                       :key="index"
                       :label="item.name"
                       :value="item.type">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年份">
          <el-date-picker type="years"
                          v-model="query.paper_years"
                          placeholder="选择一个或多个年"
                          value-format="yyyy"
                          @input="fetchExamList(true)">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="试卷标题"
                      prop="name">
          <el-input v-model="query.paper_keyword"
                    placeholder="输入关键字"
                    @input="fetchExamList(true)"
                    style="width:200px;"
                    clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     @click="handleSearch">搜索</el-button>
        </el-form-item>

      </el-form>

      <el-table :data="results"
                ref="myTable"
                :row-key="get_row_key"
                border
                @selection-change="handleSelectionChange">
        <el-table-column type="selection"
                         width="55"
                         reserve-selection>
        </el-table-column>
        <el-table-column prop="id"
                         label="ID"
                         align="center"
                         width="80">
        </el-table-column>

        <el-table-column label="题目名称"
                         align="center"
                         width="350">
          <template slot-scope="scope">
            <div style="height:20px;text-align:left;"
                 v-html="scope.row.description"></div>
          </template>
        </el-table-column>
        <el-table-column prop="answer_type_text"
                         label="题目类型"
                         align="center">
        </el-table-column>
        <el-table-column label="引用试卷"
                         align="center"
                         width="500">
          <template slot-scope="scope">
            <el-collapse v-model="scope.row.activeName"
                         accordion>
              <el-collapse-item :title="scope.row.paper_list.length?`${scope.row.paper_list[0].major_codes?`（${scope.row.paper_list[0].major_codes}）`:''}${scope.row.paper_list[0].major_names?`${scope.row.paper_list[0].major_names}`:''}《${scope.row.paper_list[0].name}》第${scope.row.paper_list[0].sort+1}题`:'无'"
                                name="1">
                <div class="collapse-div"
                     v-for="(item,index) in scope.row.paper_list"
                     :key="index">
                  <span v-if="index!=0">
                    《{{item.name}}》第{{item.sort+1}}题
                  </span>
                </div>
              </el-collapse-item>
            </el-collapse>
          </template>
        </el-table-column>
        <el-table-column label="做题人数"
                         align="center">
          <template slot-scope="scope">
            <div>{{scope.row.user_count}}人</div>
          </template>
        </el-table-column>
        <el-table-column label="做题次数"
                         align="center">
          <template slot-scope="scope">
            <div>{{scope.row.total_count}}次</div>
          </template>
        </el-table-column>
        <el-table-column label="正确率"
                         align="center">
          <template slot-scope="scope">
            <div>{{scope.row.right_rate*100}}%</div>
          </template>
        </el-table-column>

        <el-table-column label="更新时间"
                         align="center"
                         width="130">
          <template slot-scope="scope">
            <span>{{
                $moment(scope.row.create_time).format("YYYY.MM.DD")
              }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间"
                         align="center"
                         width="130">
          <template slot-scope="scope">
            <span>{{
                $moment(scope.row.create_time).format("YYYY.MM.DD")
              }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="footer">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
        <el-button type="primary"
                   @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { examPaperItemList } from '@/api/exam'
import { copyFromExamItem } from '@/api/course'
export default {
  data() {
    return {
      selection: [],
      dialogVisible: false,
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
      },
      answer_type: [
        {
          name: '单选题',
          type: 0,
        },
        {
          name: '多选题',
          type: 1,
        },
        {
          name: '名词解释',
          type: 5,
        },
        {
          name: '简答题',
          type: 6,
        },
        {
          name: '论述题',
          type: 7,
        },
        {
          name: '判断题',
          type: 3,
        },
        {
          name: '问答题',
          type: 4,
        },
        {
          name: '材料题',
          type: 8,
        },
      ],
      results: [],
      pageTotal: 0,
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    paperId: {
      type: Number,
      default: null,
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.dialogVisible = val
      }
    },
  },
  created() {
    this.fetchExamList()
  },
  methods: {
    handleSelectionChange(val) {
      this.selection = val
      console.log('section', this.selection)
    },
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchExamList()
    },
    handleClose() {
      this.dialogVisible = false
      this.selection = []
      this.$nextTick(() => {
        this.$refs.myTable.clearSelection()
      })
      this.$emit('close')
    },
    handleSubmit() {
      let itemId = []
      this.selection.map((item) => {
        itemId.push(item.id)
      })
      console.log('itemId', itemId)
      copyFromExamItem({
        arr_source_exam_item_id: itemId,
        target_measure_scroll_id: this.paperId,
      }).then((res) => {
        this.handleClose()
        this.$emit('sumbit')
      })
    },
    get_row_key(row) {
      return row.id
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchExamList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchExamList()
    },
    fetchExamList(isReset = false) {
      if (isReset) {
        this.$set(this.query, 'pageIndex', 1)
      }
      const params = Object.assign({}, this.query)

      if (params.paper_years) {
        params.paper_years = params.paper_years.filter((v) => v).join(',')
      }
      if (params.keywords) {
        params.keywords = params.keywords.split(' ').join(',')
      }
      examPaperItemList(params).then((res) => {
        this.results = res.list || []
        this.results.forEach((item) => {
          this.$set(item, 'activeName', '')
        })
        this.pageTotal = res.count
      })
      // this.syncQuery()
    },
  },
}
</script>
<style lang="less" scoped>
::v-deep .el-dialog__header {
  background: #ebeef5 !important;
}
.dialog-wrap {
  .footer {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }
}
</style>